<template>
    <div class="float-bg">
        <div class="float-box">

            <el-tooltip class="item" effect="light" content="智库" placement="left">
                <a href="/Index/dszx.html" target="_blank">
                    <span class="icon-zhiku"></span>
                </a>
            </el-tooltip>

            <el-tooltip class="item" effect="light" content="数据库" placement="left">
                <a href="http://data.100ec.cn/" target="_blank">
                    <span class="icon-shujuku"></span>
                </a>
            </el-tooltip>

            <el-tooltip class="item" effect="light" content="企业库" placement="left">
                <a href="http://cop.100ec.cn/" target="_blank">
                    <span class="icon-qiye"></span>
                </a>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Suspension'
}
</script>

<style>
.float-bg {
    position: fixed;
    right: 50px;
    bottom: 30px;
}

.float-box .item {
    margin-bottom: 20px;
}

.float-box a {
    display: block;
    background: #e4e4e4;
    border-radius: 50%;
    cursor: pointer;
    padding: 15px;
    transition: all .5s ease-in-out;
}

.float-box a:hover {
    background: dodgerblue;
}

.float-box a span {
    font-size: 24px;
    color: #fff;
}

@media (max-width: 1200px) {
    .float-bg {
        right: 10px;
    }

    .float-box .item {
        margin-bottom: 10px;
    }

    .float-box a {
        padding: 10px;
    }

    .float-box a span {
        font-size: 20px;
    }
}
</style>